"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ToolbarContainer = _styledComponents.default.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;

	@media (min-width: ${_constants.breakpoints.tablet}) {
		flex-direction: row;
		align-items: center;
		margin: 0 -8px 24px -8px;
	}
`;
const RightItems = _styledComponents.default.div`
	@media (min-width: ${_constants.breakpoints.tablet}) {
		margin-left: auto;
	}
`;
const ToolbarItem = _styledComponents.default.div`
	margin-bottom: 8px;
	width: 100%;

	@media (min-width: ${_constants.breakpoints.tablet}) {
		width: auto;
		margin-bottom: 0;
		margin: 0 8px;
	}
`;

const Toolbar = ({
  children,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(ToolbarContainer, _extends({
  role: "toolbar"
}, rest), children);

Toolbar.RightItems = RightItems;
Toolbar.Item = ToolbarItem;
var _default = Toolbar;
exports.default = _default;